<template>
  <div class="wordsEvaluation flex-column-between">
    <header class="flex-align-between teacher-head">
      <div class="flex-align-center title-box">
        <img alt="" class="ico" src="@/assets/teacher/h1-title-ico.png">
        <span class="text">投影与测评</span>
      </div>
      <div class="flex-align-center right-button">
        <!-- <div class="flex-align-center test-button-box" @click="newClassTest">
          <img alt="" class="ico" src="@/assets/teacher/button-test-ico.png">
          <span class="text">新建测评</span>
        </div> -->
        <div class="flex-align-center test-button-box" @click="resetClassTest">
          <img alt="" class="ico" src="@/assets/teacher/button-test-ico.png">
          <span class="text">重新测评</span>
        </div>
        <div class="flex-align-center back-box" @click="goback">
          <img alt="" class="back-ico" src="@/assets/teacher/back-ico.png">
          <span class="back-text">返回</span>
        </div>
      </div>
    </header>
    <div class="mianbox flex-align-between">
      <div class="mianImg">
        <Viewers ref="Viewers" :options="$route.query.type" :imgArr="imgArr" @lantern="lantern" v-if="imgArr.length != 0">
        </Viewers>
        <div class="qrcodeTip flex-align-between">
          <div class="category flex-column-center">
            <div class="flex-column-center item" @click="leftButtonListNameClick">
              <img
                :src="leftButtonListName ? require('../../assets/showreel/listNameB.png') : require('../../assets/showreel/listNameA.png')" />
              <span>测评名单</span>
            </div>
            <div class="flex-column-center item" @click="leftButtonReportJumpPage">
              <img
                :src="leftButtonReport ? require('../../assets/showreel/reportB.png') : require('../../assets/showreel/reportA.png')" />
              <span>班级报告</span>
            </div>
            <div class="flex-column-center item" v-if="!$route.query.wordName && !$route.query.className"
              @click="openPreview">
              <img
                :src="revealType ? require('../../assets/showreel/projectionB.png') : require('../../assets/showreel/projectionA.png')" />
              <span>同步投影</span>
            </div>
            <div class="flex-column-center item" @click="appraisalJumpPage">
              <img
                :src="appraisalType ? require('../../assets/showreel/appraisalB.png') : require('../../assets/showreel/appraisalA.png')" />
              <span>AI测评</span>
            </div>
          </div>
          <div class="listNameLayer" v-if="leftButtonListName">
            <div class="listNameBox">
              <div class="flex-align-between">
                <div class="className">{{ className || '班级名称' }}</div>
                <img @click="leftButtonListNameClick" class="layerClose"
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzY2NjY2NiIgc3Ryb2tlLXdpZHRoPSIxLjUiPjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEwIi8+PHBhdGggc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJtMTQuNSA5LjVsLTUgNW0wLTVsNSA1Ii8+PC9nPjwvc3ZnPg=="
                  alt="">
              </div>
              <div class="listNameTab flex-align">
                <div class="item" :class="status == 2 ? 'active' : ''" @click="tabListName(2)">未测评</div>
                <div class="item" :class="status == 1 ? 'active' : ''" @click="tabListName(1)">已测评</div>
                <div class="offline flex-align-center" @click="offline">学生下线</div>
              </div>
              <div class="listNameList">
                <div class="item" :class="{'offlineStu':offlineUserId == item.userId}" v-for="(item, index) in classTestList" :key="item.userId" @click="offlineUserId=item.userId">
                  {{ item.name }}
                </div>
              </div>
            </div>
            <img alt="" class="bg" src="@/assets/teacher/layer.png" />
          </div>
          <div v-if="previewVisible" class="image-preview-mask" @click="closePreview">
            <div class="image-preview-img" @click.stop>
              <div class="image-preview-code">
                <img alt="" class="bg" src="@/assets/teacher/code-bg.png">
                <div class="code">
                  <vue-qr :text="qrText" :size="460" :logoScale="0.3" :margin="6" />
                </div>
              </div>
            </div>
            <img class="image-preview-close" @click.stop="closePreview"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAA7CAMAAADy+wKBAAAAAXNSR0IArs4c6QAAAaFQTFRFAAAA////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////ja4xQQAAAIp0Uk5TAAEEBQYHCAkKDA0ODxESExcYGRscICIjJCYnKCkvMDIzNzg5Pj9CQ0ZHSElKS09RUlNVVldYWl1fYGFiY2RmamtsbW5vcHN0dXZ4h4iJiouQkZOUlZaXmZqdpKWrrq+wsbK3uM3O0dLV1tfY2drb3N3e3+Dh4+Tl5ufo6err7O3w8fLz9ff5+vv+T4e8owAAAz5JREFUSMedl2tDUkEQhqew1DIzK7Uou6CVlUmUXaWMTLtQmWWSZXeNoARBKi8USFE8v7oPB3IP7HoOzSfPzjysuzsz+66I1g5cGX8by/7hTzb2dvzKAXFtvskMdstM+tyAjaF5dDYfanIgG0ZXMNnKaMNG6LFYJbAUnwmHLgYuhsIz8VJlMHbcSG6ZKMcUpgfblPG2welC2TOxRY92vLf8qeHmGl/z9ZTlnO3Uod1LAGSDHu0ve4JZAJa6a309eQAiO4xL2hEBIN9T7TiYA8gHNjyFQB4gVzVz1ypAwutwhN4EwGqXOtY0BxBtd8yc9ijAnJomUwCZPS7Sbk8GYGp94ARA3l3Ge3MAfZXPrUmAcy4r5RzAwtby122AiOsyiwCMlStnBVhqcc22LAHLjSIiMgIw5L68ZQhgRERE5oG0pw7WkwY+i4j4AG6ovpPpxGl79OlE+pTyOQzgE5FJoLBNjUxDcUAd8BchrVZVAZgUkQzw3DZLEjvsLwIJNWIayIjsB7CXQH8RKPptaLFfjRgE8MpVoNRqX95ZFbbQs7aAthJwVR4BseqdVGAdKhIHxuUd8EqMsB6Vl8A7iQNhMcEGVMJATLLALU0CWJQBlVvAV/ltSkh/0eqMOlSGgDUBuCBmeP2sVLsAYJ5XBix2QIzzZv/VhBY1wNZ6DftsodZeaeAwEDWcbxktn1Htkl8Cr+UR8MlwQn7lj9q8emDl804TaoDbSsAl8QKcN6J6eBBgr8gX4EWdNTgNpMp945etSyacar+5ADyp9KtQXT1nGKBXRDbNA4nNiuvUYrLfvgH9yUWl13lSQGKTiMgYQLDe/mzVXsuP/7gXvpc1yd2qa9HBpgDuVO7BBaB0xiUaAEhW7kHpA8i5u3/32e9fkSd13vuPVUU3CxDd7YjuigLM2tRd5ypA2knn7NPoHJFDOYCcG33180j1eO8aAM9anXTdWm+t6/CypSevmfTkKgDLh3Xezg9Wc1u8ud2sYz906P+ppkhFPz8/v1Ovn6fMwv94XNHt90eCgeDIPUW3L/Rt+F4Y2+i90OhwhE2Gd8rn4UY3Ket7mqp+H00cdV/eHZcfvvn4Nc/at4+vHl7arw/6C7dGBBwGfhvqAAAAAElFTkSuQmCC">
          </div>
          <div class="qrcodeBox">
            <div class="qrcodeIconDel">
              <i class="el-icon-close" @click="revealType = false"></i>
            </div>
            <div class="qrcodeL" :class="{ qrcodeHidden: revealType }">
              <div class="qrcodeDom flex-align">
                <div class="qrcodeImg flex-align-center">
                  <img src="@/assets/assistant/qrcode.jpg" />
                </div>
                <div class="qrcodetext flex-column">
                  <span>微信扫描二维码，</span>
                  <span>打开小程序</span>
                </div>
              </div>
              <div class="text flex-align-center">
                <div class="textGuidance flex-column-between">
                  <div>教师登录“首师优字教师端小程序”后，</div>
                  <div>
                    点击
                    <img src="../../assets/assistant/camera2.png" />同步投影使用。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="workR" :class="[{ workRAff: broadsideType }, { workRW: delStatus }]">
        <div class="packUp flex-align-center" @click="packUp">
          <img :src="broadsideType ? img2 : img1" />
        </div>
        <div class="workImgList">
          <div class="workImgbox flex-align-center" :class="{ workImgAff: viewerVal == index }"
            v-for="(item, index) in imgArr" :key="index">
            <img class="label label1"
              :src="isIdentifyDoneType(item.isIdentifyDone, item.integrationLevel, item.version, item.writeCount, item.status)"
              v-if="item.version == 2 && item.isIdentifyDone != 0 && item.integrationLevel != null" />
            <img class="label label2"
              :src="isIdentifyDoneType(item.isIdentifyDone, item.level, item.version, item.writeCount, item.status)"
              v-if="item.version == 1 && item.status == 1" />
            <div class="flex-column-center">
              <div class="Img"
                @click="pitchOn(index, item.id, item.status, item.isIdentifyDone, item.bindUserName, item.bindUserId, item.version, item.writeCount)">
                <img :src="item.img2" />
              </div>
              <span style="color: #999999">{{ item.name }}</span>
            </div>
            <div class="delwords flex-column-center" v-if="delStatus">
              <img src="@/assets/assistant/del.png"
                @click="$route.query.type == 0 ? deleteTestList(item.id, index) : deleteQQTestList(item.id, index)" />
              <span>删除</span>
            </div>
          </div>
        </div>
        <div class="workBtn flex-align-center" v-if="$route.query.type == 0">
          <div class="flex-align-center" :class="{ workBtntype: workBtntype }" @click="Administration">
            {{ workBtntype ? "取消" : "管理" }}
          </div>
        </div>
      </div>
    </div>
    <div class="commentImg">
      <!-- width="30%" -->
      <el-dialog :visible.sync="commenVisible" center :show-close="false" :modal-append-to-body="false">
        <div class="commentImgbox flex-align-between">
          <div class="prev carousel" :class="{ prevAff: popupIndex == 0 }" @click="slidePrePop"></div>
          <div class="classpopBox flex-align-center">
            <div class="classpopBoxImg2 classpopBoxImg" v-if="popupIndex == 0">
              <img src="../../assets/assistant/tian.png" />
              <img :src="amplifier[0]" />
            </div>
            <div class="classpopBoxImg2 classpopBoxImg" v-if="popupIndex == 1">
              <img src="../../assets/assistant/tian.png" />
              <img :src="amplifier[1]" />
            </div>
            <div class="classpopBoxImg3 classpopBoxImg"
              v-if="popupIndex == 2 && reportData.testList[appraisalIindex].wordType == 1">
              <img :src="amplifier[2][0]" />
              <img src="../../assets/assistant/tian.png" />
              <img :src="amplifier[2][1]" />
              <img :src="amplifier[2][2]" />
            </div>
            <div class="classpopBoxImg3 classpopBoxImg"
              v-if="popupIndex == 2 && reportData.testList[appraisalIindex].wordType == 2">
              <img :src="amplifier[2][1]" />
              <img src="../../assets/assistant/tian.png" />
              <img :src="amplifier[2][0]" />
              <img :src="amplifier[2][2]" />
            </div>


            <div class="classpopBoxImg3 classpopBoxImg" v-if="popupIndex == 3">
              <img :src="amplifier[3][0]" />
              <img src="../../assets/assistant/tian.png" />
              <img :src="amplifier[3][1]" />
              <img :src="amplifier[3][2]" />
            </div>
          </div>
          <div class="next carousel" :class="{ nextAff: popupIndex == this.amplifier.length - 1 }" @click="slideNextPop">
          </div>
          <div class="popClose" @click="commenVisible = false"></div>
        </div>
      </el-dialog>
    </div>
    <!-- 视频同步投影弹窗 -->
    <el-dialog custom-class="videoDialog" :visible.sync="dialogVisible" :close-on-click-modal="false" :show-close="false">
      <div class="polyvPlayer" id='player'></div>
    </el-dialog>
    <img class="close" @click="videoClose" v-if="dialogVisible" src="@/assets/copybook/close2.png" alt="">
    <!-- 退出投影弹窗 -->
    <el-dialog custom-class="exitDialog" :visible.sync="exitDialogVisible" :close-on-click-modal="false" center
      :title="dialogTitle">
      <div class="exitWrap flex-column" v-if="step == 1">
        <div class="workName flex-align">
          <span>作品集名称</span>
          <el-input v-model="inputVal" placeholder="请输入内容"></el-input>
        </div>
        <div class="className flex-align">
          <span>授课班级</span>
          <el-select v-model="classDefault" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="menu flex-layout">
          <div class="goon" @click="goon">继续投影</div>
          <div class="exit" @click="save">保存</div>
        </div>
      </div>
      <div class="success" v-else>
        <span>作品已保存至”作品集“，可打开</span>
        <span class="saveText"><span>”首页-作品集“</span>查看作品</span>
        <div class="know" @click="know">我知道了</div>
      </div>
    </el-dialog>
    <!-- 自定义创建测评确认弹窗 -->
    <!-- <div class="confirm-mask" v-if="confirmCreateVisible">
      <div class="confirm-dialog">
        <div class="confirm-title">新建测评</div>
        <div class="confirm-content">新建测评，系统将保存本次测评结果，可在作品集里重新打开。</div>
        <div class="confirm-actions">
          <button class="btn btn-cancel" @click="confirmCreateCancel" :disabled="confirmCreating">取消</button>
          <button class="btn btn-ok" @click="confirmCreateOk" :disabled="confirmCreating">
            {{ confirmCreating ? '创建中...' : '确定' }}
          </button>
        </div>
      </div>
    </div> -->
    <div class="confirm-mask" v-if="confirmCreateVisible">
      <div class="confirm-dialog">
        <div class="confirm-title">重新测评</div>
        <div class="confirm-content">选择重新测评，将清除教师端当前课节所有作品，确定重测吗？</div>
        <div class="confirm-actions">
          <button class="btn btn-cancel" @click="confirmCreateCancel" :disabled="confirmCreating">取消</button>
          <button class="btn btn-ok" @click="confirmCreateOk" :disabled="confirmCreating">
            确定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Viewers from "../attendclass/ViewerRecord.vue";
import {
  slider,
  slideritem
} from "vue-concise-slider";
import moment from "moment";
import vueQr from 'vue-qr';
export default {
  data() {
    return {
      imgArr: [],
      broadsideType: false,
      img1: require("../../assets/assistant/packUp1.png"),
      img2: require("../../assets/assistant/packUp2.png"),
      viewerVal: 0,
      nowadayId: "",
      testStatus: null,
      Underevaluation: require("../../assets/assistant/Underevaluation.png"),
      complete: require("../../assets/assistant/complete.png"),
      labels: {
        1: require("../../assets/assistant/Toimprove.png"),
        2: require("../../assets/assistant/Toimprove.png"),
        3: require("../../assets/assistant/well.png"),
        4: require("../../assets/assistant/well.png"),
        5: require("../../assets/assistant/excellent.png"),
      },
      newlabels: {
        1: require("../../assets/assistant/Toimprove.png"),
        2: require("../../assets/assistant/qualified.png"),
        3: require("../../assets/assistant/well.png"),
        4: require("../../assets/assistant/excellent.png"),
      },
      ReportPopup: false,
      //WebSocket
      websock: null, //建立的连接
      lockReconnect: false, //是否真正建立连接
      timeout: 5 * 1000, //20秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null, //断开 重连倒计时
      date: "",
      closeJunction: '{"msg":"心跳操作","code":209}',
      reportData: "",
      throttle: 0,
      resource: false,
      delStatus: false,
      workBtntype: false,
      appraisalIindex: 0,
      loading: false,
      figureLevel: {
        1: 1,
        2: 1,
        3: 2,
        4: 2,
        5: 3,
      },
      figureName: {
        1: "待提升",
        2: "待提升",
        3: "良好",
        4: "良好",
        5: "优秀",
      },
      prevType: false,
      //文字轮播
      sliderinit: {
        currentPage: 0,
        tracking: false,
        thresholdDistance: 100,
        thresholdTime: 300,
        infinite: 6,
        slidesToScroll: 6,
        freeze: true, //禁止拖动
      },
      starList: {
        1: [
          require("../../assets/assistant/starB.png"),
          require("../../assets/assistant/starA.png"),
          require("../../assets/assistant/starA.png"),
          require("../../assets/assistant/starA.png"),
          require("../../assets/assistant/starA.png"),
        ],
        2: [
          require("../../assets/assistant/starB.png"),
          require("../../assets/assistant/starB.png"),
          require("../../assets/assistant/starA.png"),
          require("../../assets/assistant/starA.png"),
          require("../../assets/assistant/starA.png"),
        ],
        3: [
          require("../../assets/assistant/starB.png"),
          require("../../assets/assistant/starB.png"),
          require("../../assets/assistant/starB.png"),
          require("../../assets/assistant/starA.png"),
          require("../../assets/assistant/starA.png"),
        ],
        4: [
          require("../../assets/assistant/starB.png"),
          require("../../assets/assistant/starB.png"),
          require("../../assets/assistant/starB.png"),
          require("../../assets/assistant/starB.png"),
          require("../../assets/assistant/starA.png"),
        ],
        5: [
          require("../../assets/assistant/starB.png"),
          require("../../assets/assistant/starB.png"),
          require("../../assets/assistant/starB.png"),
          require("../../assets/assistant/starB.png"),
          require("../../assets/assistant/starB.png"),
        ],
      },
      nextType: false,
      amplifier: [
        [1],
        [1],
        [1, 2, 3]
      ],
      popupIndex: 0,
      commenVisible: false,
      revealType: false,
      appraisalType: false,
      indicatorValue: [],
      commentText: {
        0: [
          "篇章完整，内容正确。",
          "篇章较完整。",
          "篇章不够完整，要正确的书写所有内容。",
        ],
        1: [
          "布局协调，占格居中。",
          "布局基本合理，注意重心位置。",
          "布局不够整齐，注意上下左右保持对齐。",
        ],
        2: [
          "字的大小适中，书写流畅。",
          "书写大小基本均匀，内部空间不足。",
          "字的书写偏差较大，整体偏大/小，主笔位置需找准。",
        ],
        3: [
          "书写工整规范，运笔准确。",
          "书写基本规范，结构需严谨。",
          "书写不够规范，部件位置应准确。",
        ],
      },
      // 作品完整度
      IntegrityText: "",
      //布局整齐度
      uniformityText: "",
      //占格一致性
      AestheticsText: "",
      // 例字相似性
      NormativeText: "",
      focusNum: 0,
      focusIndex: 0,
      dialogVisible: false,
      exitDialogVisible: false,
      player: '',
      vodPlayerJs: 'https://player.polyv.net/script/player.js',
      options: [],
      classDefault: '',
      inputVal: '', //作品集名称
      showClassName: true,
      saveText: '保存并退出',
      vid: null,
      currentTime: null,
      playsafe: '', //解密凭证
      dialogTitle: '退出投影',
      step: 1,
      userStatus: true, // 身份状态 false == 401 身份过期      true 身份未过期
      versionAi: null,
      intervalId: null,
      bindUserName: null,
      bindUserId: null,
      writeCount: null,

      //lzp新增
      classId: '',
      testId: '',
      status: '2',
      className: '',
      classTestList: [],
      leftButtonListName: false,
      leftButtonReport: false,
      refreshTimer: null, // 定时器
      // 自定义确认弹窗
      confirmCreateVisible: false,
      confirmCreating: false,
      // 同步投影二维码弹窗
      previewVisible: false,
      qrText: '',
      evalNum: 1,
      eventSource: null,
      offlineUserId:null
    };
  },
  components: {
    Viewers,
    slider,
    slideritem,
    vueQr
  },
  watch: {
    // lessonId 变化时自动拉取一次作品列表
    lessonId(newVal, oldVal) {
      if (newVal && newVal !== oldVal && typeof this.getWordImg === 'function') {
        this.getWordImg();
      }
    }
  },
  //方法
  methods: {
    tabListName(e) {
      console.log(e)
      this.status = e || '';
      this.loadClassTestList()
    },
    async newClassTest() {
      // 打开自定义确认弹窗
      this.confirmCreateVisible = true;
    },
    // 再次测评确定
    // async confirmCreateOk() {
    //   if (this.confirmCreating) return;
    //   this.confirmCreating = true;
    //   try {
    //     // 先保存当前测评，成功后再新建
    //     if (this.imgArr && this.imgArr.length > 0) {
    //       const data = {
    //         name: this.inputVal,
    //         classId: this.classDefault,
    //         lessonId: this.lessonId
    //       };
    //       const res = await this.$Api.CopyBook.saveLiving(data);
    //       if (!(res && res.code === 200)) {
    //         if (this.$message) {
    //           this.$message.error((res && res.msg) || '保存当前测评失败');
    //         }
    //         return;
    //       }
    //     }
    //     await this.proceedCreateClassTest();
    //     this.confirmCreateVisible = false;
    //   } finally {
    //     this.confirmCreating = false;
    //   }
    // },
    // 重新测评确定
    async confirmCreateOk() {
      let resData = await this.$Api.StuTest.resetTest(`testId=${this.testId}&classId=${this.classId}`);
      this.confirmCreateVisible = false;
      console.log('教师端重新测评', resData);
      this.getEvalNum(this.testId)
    },
    confirmCreateCancel() {
      if (this.confirmCreating) return;
      this.confirmCreateVisible = false;
    },
    async proceedCreateClassTest() {
      try {
        const lessonId = Math.floor(Date.now() / 1000);
        const res = await this.$Api.CopyBook.createClassTest({
          classId: this.classId,
          lessonId: lessonId
        });
        if (res && res.code === 200 && res.data) {
          const classData = {
            classId: this.classId,
            className: this.className || '',
            testId: res.data,
            lessonId: lessonId,
            timestamp: Date.now()
          };
          sessionStorage.setItem('selectedClassData', JSON.stringify(classData));
          sessionStorage.setItem('testId', JSON.stringify(res.data));
          this.testId = res.data;
          this.lessonId = lessonId;
          if (this.$message) {
            this.$message.success('创建班级测评成功');
          }
          if (this.$router && this.$route) {
            try {
              await this.$router.replace({
                query: {
                  ...this.$route.query,
                  classId: this.classId,
                  testId: this.testId,
                  lessonId: this.lessonId,
                }
              });
            } catch (e) { }
          }
          // 若 WS 未连接，尝试重连
          try {
            if (!this.websock || this.websock.readyState !== 1) {
              this.initWebSocket && this.initWebSocket();
            }
          } catch (e) { }
          // 重置节流标记，允许 1002 首次推送触发刷新
          this.throttle = 0;
          if (typeof this.websocketsend === 'function') {
            this.websocketsend();
          }
          // 延迟再推送一次，确保后端收到最新路由
          setTimeout(() => {
            if (typeof this.websocketsend === 'function') {
              this.websocketsend();
            }
          }, 500);
          // 清空并按新 lessonId 拉取作品
          this.imgArr = [];
          this.viewerVal = 0;
          this.nowadayId = '';
          this.resource = false;
          if (typeof this.getWordImg === 'function') {
            this.getWordImg();
          }
          // 启动短期轮询，等待后端数据就绪后停止
          try { if (this.refreshTimer) { clearInterval(this.refreshTimer); this.refreshTimer = null; } } catch (e) { }
          this.refreshTimer = setInterval(() => {
            if (typeof this.getWordImg === 'function') {
              this.getWordImg();
            }
          }, 3000);
          setTimeout(() => { // 最长等待 30s 自动停止
            if (this.refreshTimer) { clearInterval(this.refreshTimer); this.refreshTimer = null; }
          }, 30000);
          // 刷新测评名单（使用新 testId）
          this.loadClassTestList();
        } else {
          if (this.$message) {
            this.$message.error((res && res.msg) || '创建班级测评失败');
          }
        }
      } catch (e) {
        if (this.$message) {
          this.$message.error('创建班级测评失败');
        }
      }
    },
    async loadClassTestList() {
      try {
        this.loadingList = true;
        const params = {
          classId: this.classId,
          testId: this.testId,
          status: this.status
        };
        const res = await this.$Api.CopyBook.queryClassTestList(params);
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.classTestList = res.data;
        }
      } catch (e) {
        this.classTestList = [];
        if (this.$message) {
          this.$message.error('获取测评列表失败');
        }
      } finally {
        this.loadingList = false;
      }
    },
    goback() {
      this.userStatus = false;
      if (this.$route.query.lessonId) {
        this.websocketclose();
        this.websock.send(this.closeJunction);
        this.$router.go(-1);
      } else {

        if (this.imgArr.length == 0) {
          this.websocketclose();
          this.websock.send(this.closeJunction);
          if (window.history.length > 1) {
            this.$router.go(-1); // 如果有上一页，返回上一页
          } else {
            window.close(); // 如果没有上一页，关闭当前页
          }
          // this.$router.go(-1);
          // this.saveText = "退出";
          // this.showClassName = true;
        } else {
          this.exitDialogVisible = true;
          this.saveText = "保存并退出";
          this.showClassName = false;
        }
      }
    },
    // 继续投影
    goon() {
      this.exitDialogVisible = false;
    },
    // 保存并退出
    save() {
      // 调用保存接口，保存后退出
      // console.log('调用保存接口，保存后退出');
      if (!this.inputVal) {
        this.$message({
          message: '请填写作品集名称',
          type: 'warning'
        });
        return
      }
      if (!this.classDefault) {
        this.$message({
          message: '请选择授课班级',
          type: 'warning'
        });
        return
      }
      let data = {
        name: this.inputVal,
        classId: this.classDefault,
        lessonId: this.lessonId
      }
      this.$Api.CopyBook.saveLiving(data)
        .then(res => {
          // console.log('保存成功', res);
          if (res.code == 200) {
            this.dialogTitle = '保存成功';
            this.step = 2;
          }
        })
        .catch(err => {
          console.log('保存失败', err)
        })
    },
    async know() {
      this.websocketclose();
      this.websock.send(this.closeJunction);
      try {
        let data = {
          testId: this.testId
        }
        const res = await this.$Api.CopyBook.putClassTestEnd(data);
        console.log(res)
        if (res && res.data.code === 200) {
          this.$router.push({ name: 'Home' });
        } else {
          if (this.$message) {
            this.$message.error((res && res.msg) || '下课失败');
          }
        }
      } catch (e) {
        console.log('老师下课接口调用失败', e);
        if (this.$message) {
          this.$message.error('下课失败');
        }
      }
    },
    // 退出
    exit() {
      this.imgArr = [];
      this.viewerVal = 0;
      this.exitDialogVisible = true;
      this.websocketclose();
      this.websock.send(this.closeJunction);

      // this.$router.go(-1);
      if (window.history.length > 1) {
        this.$router.go(-1); // 如果有上一页，返回上一页
      } else {
        window.close(); // 如果没有上一页，关闭当前页
      }
    },
    lantern(data) {
      data ? this.prev() : this.next();
    },
    //右侧作业列表收起切换
    packUp() {
      this.broadsideType = !this.broadsideType;
    },
    //点击右侧作业列表切换图片 -- 测试内容
    pitchOn(index, id, status, isIdentifyDone, bindUserName, bindUserId, version, writeCount) {
      this.appraisalIindex = 0;
      this.viewerVal = index;
      this.nowadayId = id;
      this.bindUserName = bindUserName;
      this.bindUserId = bindUserId;
      this.testStatus = status;
      this.isIdentifyDoneStatus = isIdentifyDone;
      this.versionAi = version;
      this.writeCount = writeCount;
      let that = this;
      this.$nextTick(() => {
        that.$refs.Viewers.Index = that.viewerVal;
      });
      //this.inputVal = `同步投影1-${this.imgArr[index].startTime}`
      this.inputVal = `同步投影-${this.lessonId}`
    },
    async deleteTestList(id, index) {
      let data = {
        ids: id,
      };

      let resData = await this.$Api.Myclass.deleteTestList(data);
      if (resData.code == 200) {
        this.$message({
          message: "删除成功",
          center: true,
          type: "success",
        });
        this.IndexChange(index);
        this.imgArr.splice(index, 1);
        this.resource = this.imgArr.length == 0 ? false : true;
      }
    },
    async deleteQQTestList(id, index) {
      let data = {
        ids: id,
      };
      let resData = await this.$Api.Myclass.deleteQQTestList(data);
      if (resData.code == 200) {
        this.$message({
          message: "删除成功",
          center: true,
          type: "success",
        });
        this.IndexChange(index);
        this.imgArr.splice(index, 1);
        this.resource = this.imgArr.length == 0 ? false : true;
      }
    },
    IndexChange(index) {
      if (index == this.imgArr.length - 1 && index == this.viewerVal) {
        this.imgArr.splice(index, 1);
        this.viewerVal = index - 1;
        let that = this;
        this.$nextTick(() => {
          that.$refs.Viewers.Index = that.viewerVal;
        });
      }
    },
    // 获取身份信息
    // getUserInfo() {
    //     let that = this;

    // },
    //作品集管理
    Administration() {
      this.workBtntype = !this.workBtntype;
      this.delStatus = !this.delStatus;
    },
    //初始化 websocket
    initWebSocket() {
      //建立连接
      // let wsuri = `apitest.lezhireading.com/api/learn/socket/projection/video/${sessionStorage.getItem("teacherId")}`;
      let wsuri = `yunapi.cnuzi.com/api/learn/socket/projection/video/${sessionStorage.getItem("teacherId")}`
      //建立连接
      this.websock = new WebSocket("wss://" + wsuri);
      //连接成功
      this.websock.onopen = this.websocketonopen;
      //连接错误
      this.websock.onerror = this.websocketonerror;
      //接收信息
      this.websock.onmessage = this.websocketonmessage;
      //连接关闭
      // this.websock.onclose = this.websocketclose;
    },
    //重新连接 websocket
    reconnect() {
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function () {
        //新连接
        that.initWebSocket();
        that.lockReconnect = false;
      }, 5000);
    },
    //重置心跳
    reset() {
      var that = this;
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      //重启心跳
      that.start();
    },
    //开启心跳
    start() {
      var self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);

      self.timeoutObj = setInterval(function () {
        //这里发送一个心跳，后端收到后，返回一个心跳消息
        // console.log('self.websock.readyState', self.websock.readyState)
        self.$Api.Home.getUserInfo().then((resData) => {
          // console.log('身份状态', resData)
          if (resData.status == 401 || !self.userStatus) {
            // that.userStatus = false;
            clearTimeout(self.timeoutObj);
            clearTimeout(self.serverTimeoutObj);
            return;
          }
          if (self.websock.readyState == 1) {
            // console.log('self.date', self.date)
            // self.websock.send(self.date);
            // self.websocketsend();
            self.websock.send(JSON.stringify({
              name: "heartbeat",
              code: 201
            }));
          } else {
            // if (!self.userStatus) {
            //     clearTimeout(self.timeoutObj);
            //     clearTimeout(self.serverTimeoutObj);
            //     return;
            // }
            //否则重连
            self.reconnect();
            // self.serverTimeoutObj = setTimeout(function () {
            //   //超时关闭
            //   self.websock.close();
            // }, self.timeout);
          }

        });
      }, self.timeout);
    },
    //websocket 连接成功回调
    websocketonopen() {
      // console.log('websocket连接成功')
      //连接成功事件
      this.websocketsend();
      //提示成功
      //开启心跳
      this.start();
    },
    //websocket 连接失败回调
    websocketonerror(e) {
      // console.log('websocket连接失败', e)
      //连接失败事件
      //错误
      //重连
      // this.reconnect();
    },
    //websocket 连接关闭回调
    websocketclose(e) {
      // console.log('websocket连接关闭')
      //连接关闭事件
      //提示关闭
      //重连
      // this.reconnect();
      clearInterval(this.timeoutObj);
      this.timeoutObj = null;
      // if (this.websock && this.websock.readyState !== WebSocket.CLOSED) {
      //     this.websock.close();  // 确保关闭连接
      //     // 111111
      // }
    },
    //websocket 接收服务器推送的信息
    websocketonmessage(event) {
      let data = JSON.parse(event.data);
      console.log('//接收服务器推送的信息', data)
      if (this.throttle == 0 && data.data.code == 1002) {
        this.getWordImg();
        this.throttle = 1;
      }
      if (data.data.code == 1001) {
        this.getWordImg();
      }
      if (data.code == 1003) {
        this.destroyed();
        this.vid = JSON.parse(data.data.code).code;
        this.currentTime = JSON.parse(data.data.code).currentTime
        this.dialogVisible = true;
        this.loadPlayer();
      }
      // data.code = 200;
      //收到服务器信息，心跳重置
      this.reset();
    },
    //websocket 发送信息
    websocketsend() {
      // console.log('websocket发送信息')
      let msg = {
        code: 2001,
        data: JSON.stringify(this.$route.query),
      };
      // this.date = JSON.stringify(msg);
      //向服务器发送信息
      // console.log('//向服务器发送信息', JSON.stringify(msg))
      this.websock.send(JSON.stringify(msg));
    },
    //学生作品列表
    async getWordImg() {
      try {
        let data = {
          wordId: '',
          lessonId: this.lessonId,
          socketType: 3,
          evalNum: this.evalNum
        };
        let resData = await this.$Api.Myclass.queryTeaUploadWorksList(data);
        if (!resData || !resData.data || !Array.isArray(resData.data)) {
          console.warn('getWordImg: 接口返回数据格式异常', resData);
          this.imgArr = [];
          this.resource = false;
          return;
        }
        if (resData.data.length == 0) {
          this.imgArr = [];
          this.resource = false;
          return;
        }
        this.resource = true;
        this.imgArr = [];
        for (let i = 0; i < resData.data.length; i++) {
          this.imgArr.push({
            img1: resData.data[i].filePath,
            img2: resData.data[i].thumbFilePath,
            name: resData.data[i].bindUserName,
            id: resData.data[i].id,
            bindUserName: resData.data[i].bindUserName,
            bindUserId: resData.data[i].bindUserId,
            level: resData.data[i].level,
            integrationLevel: resData.data[i].integrationLevel,
            status: resData.data[i].status,
            // deg: angle,
            L: null,
            T: null,
            multiples: 1,
            score: resData.data[i].score,
            startTime: resData.data[i].startTime,
            lessonId: resData.data[i].lessonId,
            isIdentifyDone: resData.data[i].isIdentifyDone,
            version: resData.data[i].version,
            writeCount: resData.data[i].writeCount,
            deg: 0
          });
        }

        if (this.imgArr.length > 0) {
          //this.inputVal = `同步投影-${this.imgArr[0].startTime}`
          this.inputVal = `同步投影-${this.lessonId}`
          // 如开启了轮询，拿到数据后停止
          try { if (this.refreshTimer) { clearInterval(this.refreshTimer); this.refreshTimer = null; } } catch (e) { }
        }
        if (this.resource) this.estimate();
      } catch (error) {
        console.error('getWordImg: 获取学生作品列表失败', error);
        this.imgArr = [];
        this.resource = false;
      }
    },
    //判断当前索引
    estimate() {
      let that = this;
      let result = this.imgArr.findIndex((item) => {
        return item.id == that.nowadayId;
      });
      if (result != -1) {
        this.viewerVal = result;
      } else if (this.viewerVal > this.imgArr.length - 1) {
        this.viewerVal = this.imgArr.length - 1;
      }
      this.nowadayId = this.imgArr[this.viewerVal].id;
      this.bindUserName = this.imgArr[this.viewerVal].bindUserName;
      this.bindUserId = this.imgArr[this.viewerVal].bindUserId;
      this.testStatus = this.imgArr[this.viewerVal].status;
      this.isIdentifyDoneStatus = this.imgArr[this.viewerVal].isIdentifyDone;
      this.versionAi = this.imgArr[this.viewerVal].version;
      this.writeCount = this.imgArr[this.viewerVal].writeCount;
      if (this.resource) {
        setTimeout(() => {
          that.$nextTick(() => {
            that.$refs.Viewers.Index = that.viewerVal;
          });
        }, 1)
      }
    },
    //学生测评报告
    async getreport() {
      let that = this;
      let data = {
        uploadId: this.nowadayId,
      };
      let resData = await this.$Api.Myclass.getTeachAssessReport(data);
      this.reportData = resData.data;
      if (this.reportData.testList.length != 0) {
        this.spreadPdf(0);
      }
      this.indicatorValue = [
        Math.round((this.reportData.writeCount * 100) / this.reportData.maxNum),
        Math.round(this.reportData.locationOffset - 0),
        Math.round(this.reportData.sizeOffset - 0),
        Math.round(this.reportData.scoreAvg - 0),
      ];
      this.focusNum = Math.ceil(this.reportData.testList.length / 6);
      this.IntegrityText =
        this.commentText[0][this.comments(this.indicatorValue[0])];
      this.uniformityText =
        this.commentText[1][this.comments(this.indicatorValue[1])];
      this.AestheticsText =
        this.commentText[2][this.comments(this.indicatorValue[2])];
      this.NormativeText =
        this.commentText[3][this.comments(this.indicatorValue[3])];
      setTimeout(() => {
        that.drawRadar1();
      }, 1000);
    },
    //个人测评报告
    async getAssessReport() {
      let that = this;
      let data = {
        uploadId: this.nowadayId,
        type: 3,
      };
      let resData = await this.$Api.Myclass.getAssessReport(data);
      this.reportData = resData.data;
      if (this.reportData.testList.length != 0) {
        this.spreadPdf(0);
      }
      this.indicatorValue = [
        Math.round((this.reportData.writeCount * 100) / this.reportData.maxNum),
        Math.round(this.reportData.locationOffset - 0),
        Math.round(this.reportData.sizeOffset - 0),
        Math.round(this.reportData.scoreAvg - 0),
      ];
      this.focusNum = Math.ceil(this.reportData.testList.length / 6);
      this.IntegrityText =
        this.commentText[0][this.comments(this.indicatorValue[0])];
      this.uniformityText =
        this.commentText[1][this.comments(this.indicatorValue[1])];
      this.AestheticsText =
        this.commentText[2][this.comments(this.indicatorValue[2])];
      this.NormativeText =
        this.commentText[3][this.comments(this.indicatorValue[3])];
      setTimeout(() => {
        that.drawRadar1();
      }, 1);
    },
    //向父组件图片放大弹窗传递数据
    spreadPdf(value) {
      let spread;
      if (this.reportData.testList[value].resFilename) {
        if (this.reportData.testList[this.appraisalIindex].wordType == 1) {
          spread = [
            [this.reportData.testList[value].wordCover],
            [this.reportData.testList[value].resFilename ? this.reportData.testList[value].resFilename : this.reportData.testList[value].imagePath],
            [
              this.reportData.testList[value].wordShadowCover,
              this.reportData.testList[value].imagePath,
              this.reportData.testList[value].wordSkillCover,
            ],
            [
              this.reportData.testList[value].wordShadowCover,
              this.reportData.testList[value].resFilename,
              this.reportData.testList[value].wordSkillCover,
            ],
          ]
        } else {
          spread = [
            [this.reportData.testList[value].wordCover],
            [this.reportData.testList[value].resFilename ? this.reportData.testList[value].resFilename : this.reportData.testList[value].imagePath],
            [
              this.reportData.testList[value].wordShadowCover,
              this.reportData.testList[value].resFilename,
              this.reportData.testList[value].wordSkillCover,
            ],
          ]
        }

      } else {
        spread = [
          [this.reportData.testList[value].wordCover],
          [this.reportData.testList[value].resFilename ? this.reportData.testList[value].resFilename : this.reportData.testList[value].imagePath],
          [
            this.reportData.testList[value].wordShadowCover,
            this.reportData.testList[value].imagePath,
            this.reportData.testList[value].wordSkillCover,
          ],
        ]
      }
      this.amplifier = spread;
      // console.log('this.amplifier', this.amplifier);

    },
    //图片放大
    amplification(index) {
      this.commenVisible = true;
      this.popupIndex = index;
    },
    prev() {
      if (this.viewerVal > 0) {
        this.viewerVal--;
        this.pitchOn(
          this.viewerVal,
          this.imgArr[this.viewerVal].id,
          this.imgArr[this.viewerVal].status,
          this.imgArr[this.viewerVal].isIdentifyDone,
          this.imgArr[this.viewerVal].bindUserName,
          this.imgArr[this.viewerVal].bindUserId,
          this.imgArr[this.viewerVal].version,
        );
      }
    },
    next() {
      if (this.viewerVal < this.imgArr.length - 1) {
        this.viewerVal++;
        this.pitchOn(
          this.viewerVal,
          this.imgArr[this.viewerVal].id,
          this.imgArr[this.viewerVal].status,
          this.imgArr[this.viewerVal].isIdentifyDone,
          this.imgArr[this.viewerVal].bindUserName,
          this.imgArr[this.viewerVal].bindUserId,
          this.imgArr[this.viewerVal].version,
        );
      }
    },
    slidePrePop() {
      if (this.popupIndex > 0) {
        this.popupIndex--;
      }
    },
    slideNextPop() {
      if (this.popupIndex < (this.amplifier.length == 4 ? 3 : 2)) {
        this.popupIndex++;
      }
    },
    handleClose() {
      this.ReportPopup = false;
      this.appraisalType = false;
      this.focusNum = 0;
      this.focusIndex = 0;
      this.appraisalIindex = 0;
      this.$refs.slider.$emit("slideTo", 0);
    },
    //测评切换
    report() {
      console.log('this.testStatus:', this.testStatus)
      const end = () => { this.appraisalType = false };

      switch (this.testStatus) {
        case 0: {
          this.$confirm(`报告生成中请稍后再试(uploadId:${this.nowadayId})`, "提示", {
            confirmButtonText: "确定",
            type: "success",
            center: true,
            showCancelButton: false,
          }).then(end).catch(end);
          return;
        }
        case 1: {
          this.reportType = true;
          this.appraisalType = false;
          if (this.versionAi == 2) {
            if (this.isIdentifyDoneStatus == 0) {
              this.$confirm("报告生成中请稍后再试", "提示", {
                confirmButtonText: "确定",
                type: "success",
                center: true,
                showCancelButton: false,
              }).then(end).catch(end);
              return;
            }
            const routeData = this.$router.resolve({
              path: '/examPaperTest',
              query: {
                reportId: this.nowadayId,
                bindUserName: this.bindUserName,
                bindUserId: this.bindUserId,
                versionAi: this.versionAi,
                writeCount: this.writeCount,
              }
            });
            window.open(routeData.href, '_blank');
            return;
          }
          this.ReportPopup = true;
          this.getreport();
          this.loading = false;
          return;
        }
        case 2: {
          this.$confirm(`报告生成失败,请联系管理员(uploadId:${this.nowadayId})`, "提示", {
            confirmButtonText: "确定",
            type: "success",
            center: true,
            showCancelButton: false,
          }).then(end).catch(end);
          return;
        }
        case 3: {
          this.$confirm(`该内容非本课作品，请检查后重新提交(uploadId:${this.nowadayId})`, "提示", {
            confirmButtonText: "确定",
            type: "success",
            center: true,
            showCancelButton: false,
          }).then(end).catch(end);
          return;
        }
        case 4: {
          this.$confirm(`未识别到要测评的生字，请重新拍摄(uploadId:${this.nowadayId})`, "提示", {
            confirmButtonText: "确定",
            type: "success",
            center: true,
            showCancelButton: false,
          }).then(end).catch(end);
          return;
        }
        case 5: {
          this.$confirm(`<span style="font-size:16px">测评不成功(uploadId:${this.nowadayId})，请检查是否满足以下条件：<br/>1.系统只支持带有二维码的作品进行测评；<br/>2.作品需完整（包含外边框）、清晰、无损坏。<span/>`, "提示", {
            confirmButtonText: "我知道了",
            type: "success",
            center: true,
            showCancelButton: false,
            dangerouslyUseHTMLString: true,
            customClass: 'customClass'
          }).then(end).catch(end);
          return;
        }
        case 6: {
          this.$confirm("该字暂不支持测评", "提示", {
            confirmButtonText: "确定",
            type: "success",
            center: true,
            showCancelButton: false,
          }).then(end).catch(end);
          return;
        }
        default: {
          if (this.$message) {
            this.$message.warning('无法识别的测评状态');
          }
        }
      }
    },
    permission() {
      const schoolId = sessionStorage.getItem('schoolId');
      const gradeId = sessionStorage.getItem('gradeId');
      return schoolId === '181195' || (schoolId === '181077' && ['3', '4'].includes(gradeId));
    },
    // 角标状态
    isIdentifyDoneType(type, level, version, writeCount, status) {
      if (version == 1) {
        if (writeCount == 0) {
          return this.complete;
        } else {
          return this.labels[level];
        }

      } else {
        if (writeCount == 0) {
          return this.complete;
        } else {
          if (type == 1) {
            return this.Underevaluation;
          } else if (type == 2) {
            return this.newlabels[level];
          }
        }

      }

    },
    //测评
    slide(data) {
      this.focusIndex = Math.ceil(data.currentPage / 6);
      if (data.currentPage == 0) {
        this.nextType = true;
        this.prevType = false;
      } else if (data.currentPage > this.reportData.testList.length - 6) {
        this.nextType = false;
        this.prevType = true;
      } else {
        this.nextType = true;
        this.prevType = true;
      }
    },
    //测试上下一页
    slideNext() {
      this.$refs.slider.$emit("slideNext");
    },
    //测试上一页
    slidePre() {
      this.$refs.slider.$emit("slidePre");
    },
    //整体测评点击切换
    switchover(index) {
      this.appraisalIindex = index;
      this.spreadPdf(index);
    },
    qrcodeShow() {
      this.revealType = !this.revealType;
      // this.resource = false;
    },
    appraisalShow() {
      this.appraisalType = !this.appraisalType;
      let that = this;
      this.report();
    },
    leftButtonListNameClick() {
      this.leftButtonListName = !this.leftButtonListName;
      console.log(this.leftButtonListName);
    },
    leftButtonReportJumpPage(lessonId) {
      // this.$message.warning("暂未开放");
      this.leftButtonReport = !this.leftButtonReport

      // const hashPath = 'https://ssyzpccdn.lezhireading.com/newreport2';
      const hashPath = 'https://yun.cnuzi.com/newreport2';
      const params = `schoolId=${encodeURIComponent(this.schoolId || '')}&schoolName=${encodeURIComponent(this.schoolName || '')}&fromType=home&lessonId=${this.lessonId}&className=${this.className}`;
      let jumpUrl = `${hashPath}?${params}`;
      // this.$router.push(jumpUrl)

      window.open(jumpUrl, '_blank');

    },
    appraisalJumpPage() {
      this.appraisalType = !this.appraisalType;
      this.report();
    },
    contains(arr, obj) {
      var i = arr.length;
      while (i--) {
        if (arr[i].name === obj) {
          return i;
        }
      }
      return false;
    },
    drawRadar1() {
      this.$echarts.init(document.getElementById("myChart")).dispose();
      let that = this;
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      let indicator = [{
        name: "作品完整度",
        max: 100
      },
      {
        name: "布局整齐度",
        max: 100
      },
      {
        name: "占格一致性",
        max: 100
      },
      {
        name: "例字相似性",
        max: 100
      },
      ];
      let dataArr = [{
        value: that.indicatorValue,
      },];
      myChart.setOption({
        radar: {
          radius: "60%",
          name: {
            formatter: (value) => {
              let i = that.contains(indicator, value);
              return (
                "{b|" +
                value +
                "}\n" +
                "{a|" +
                that.indicatorValue[i] +
                "%" +
                "}"
              );
            },
            rich: {
              a: {
                align: "center",
                color: "#E77903",
                fontSize: 11,
              },
              b: {
                align: "center",
                color: "#151515",
                fontSize: 11,
                height: 20,
              },
            },
          },

          nameGap: 8,
          indicator: indicator,
          splitLine: {
            show: false,
          },
          splitArea: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: [{
          type: "radar",
          symbolSize: 10,
          symbol: "none",
          lineStyle: {
            width: 2,
            color: "#E77903",
          },
          data: dataArr,
          areaStyle: {
            color: "#E77903",
            opacity: 0.3,
          },
        },],
      });
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    comments(value) {
      let index = value <= 60 ? 2 : value >= 80 ? 0 : 1;
      return index;
    },
    slideTo(value) {
      this.$refs.slider.$emit("slideTo", value * 6);
    },
    //  ------ 1.9需求新增 ------
    videoClose() {
      this.dialogVisible = false;
      this.destroyed()
    },
    loadPlayerScript(callback) {
      if (!window.polyvPlayer) {
        const myScript = document.createElement('script');
        myScript.setAttribute('src', this.vodPlayerJs);
        myScript.onload = callback;
        document.body.appendChild(myScript);
      } else {
        callback();
      }
    },
    loadPlayer() {
      this.$nextTick(() => {
        const polyvPlayer = window.polyvPlayer;
        this.player = polyvPlayer({
          wrap: '#player',
          vid: this.vid,
          watchStartTime: this.currentTime,
          autoplay: true
        });
      })

    },
    destroyed() {
      if (this.player) {
        this.player.destroy();
      }
    },
    // 保存投影作品获取班级列表
    getClassList() {
      this.$Api.CopyBook.getClassList()
        .then(res => {
          console.log('保存投影作品获取班级列表',res)
          this.options = res.data;
          // this.classDefault = res.data[0].id
          this.classDefault = Number(this.$route.query.classId)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 格式化时间方法
    formatTimeStamp(timestamp, format) {
      if (!timestamp) {
        return 0;
      }
      let formatTime;
      const formatStr = format || 'yyyy-MM-dd hh:mm:ss';
      const date = new Date(timestamp);
      const o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
      };
      if (/(y+)/.test(formatStr)) {
        formatTime = formatStr.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));
      } else {
        formatTime = formatStr;
      }
      for (const k in o) {
        if (new RegExp(`(${k})`).test(formatTime)) {
          formatTime = formatTime.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(
            `${o[k]}`
              .length));
        }
      }
      return formatTime;
    },
    // 同步投影二维码弹窗
    openPreview() {
      this.buildQrText();
      this.previewVisible = true;
    },
    closePreview() {
      this.previewVisible = false;
    },
    buildQrText() {
      const teacherId = sessionStorage.getItem('teacherId') || '';
      const hashPath = 'https://yun.cnuzi.com/student/classMates'; // 正式
      // const hashPath = 'https://ssyzpccdn.lezhireading.com/student/classMates'; // 测试
      const params = `classId=${encodeURIComponent(this.classId || '')}&testId=${encodeURIComponent(this.testId || '')}&teacherId=${encodeURIComponent(teacherId || '')}&t=${Date.now()}`;
      this.qrText = `${hashPath}?${params}`;
      console.log(this.qrText);
    },
    // 重新测评
    resetClassTest() {
      this.confirmCreateVisible = true
    },
    // 获取当前测评次序
    async getEvalNum(testId) {
      let data = {
        testId
      }
      let resData = await this.$Api.StuTest.getEvalNum(data);
      console.log('获取当前测评次序',resData);
      this.evalNum = resData.data;
      this.getWordImg()
    },
    // 学生下线
    async offline(){
      let resData = await this.$Api.StuTest.offlineStudent(`testId=${this.testId}&studentId=${this.offlineUserId}`)
      console.log('学生下线',resData);
      this.$message({
        message: '下线成功',
        type: 'success'
      });
    }
  },
  created() {
    // 获取到参数{"classId":30036,"className":"八年级1班","testId":21,"lessonId":1760172354,"timestamp":1760172354949}
    this.classId = (this.$route && this.$route.query && this.$route.query.classId) || '';
    this.testId = (this.$route && this.$route.query && this.$route.query.testId) || '';
    this.schoolId = sessionStorage.getItem('schoolId') || '';
    this.schoolName = sessionStorage.getItem('schoolName') || '';
    // 从 sessionStorage 获取班级名称
    const classDataStr = sessionStorage.getItem('selectedClassData');
    if (classDataStr) {
      const classData = JSON.parse(classDataStr);
      this.className = classData.className || '';
      this.lessonId = classData.lessonId || '';
    } else {
      this.className = '';
      this.lessonId = '';
    }
  },
  mounted() {
    this.initWebSocket()
    this.getClassList();
    // 测评名单
    this.loadClassTestList();
    // 启动定时刷新 测评名单
    //this.startRefreshTimer();
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    clearInterval(this.intervalId);
    try { if (this.refreshTimer) { clearInterval(this.refreshTimer); this.refreshTimer = null; } } catch (e) { }
  },
};
</script>
<style lang='less' scoped>
@import "./less/newSyncProjection.less";
@import "./less/classTestMain.less";

.carouselMian {
  height: 140px;
  width: 810px;

  /deep/ .slider-wrapper {
    margin: 0 2px;
  }

  /deep/ .slider-item {
    width: 112.4px !important;
    height: 135px !important;
    margin-right: 26px;
  }

  /deep/ .slider-pagination {
    display: none;
    // bottom: 0px;
  }

  /deep/ .swiper-container-horizontal>*>.slider-pagination-bullet {
    width: 20px !important;
    height: 8px !important;
    border-radius: 14px;
    background-color: #c2c2c2;
  }

  /deep/ .swiper-container-horizontal .slider-pagination-bullet-active {
    background-color: #89dcc9;
  }
}

/* 自定义确认弹窗样式 */
.confirm-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}

.confirm-dialog {
  width: 840px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.confirm-title {
  padding: 30px;
  font-size: 32px;
  font-weight: 600;
  border-bottom: 1px solid #f0f0f0;
}

.confirm-content {
  padding: 30px;
  font-size: 28px;
  color: #333;
}

.confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 30px;
}

.btn {
  min-width: 144px;
  height: 64px;
  padding: 0 24px;
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  font-size: 28px;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-cancel {
  background: #fff;
  border-color: #d9d9d9;
  color: #333;
}

.btn-ok {
  background: #166a50;
  border-color: #166a50;
  color: #fff;
}
</style>
